import { useTranslation } from 'react-i18next';

import * as St from './DrawingAreaDescriptor.styles';

import QuickEstimateIcon from '~/icons/QuickEstimate.svg';
import AddShapeIcon from '~/icons/add_Shape.svg';
import DrawIcon from '~/icons/draw.svg';
import DrawingAreaText from '~molecules/DrawingAreaText';

const DrawingAreaDescriptor = () => {
  const { t } = useTranslation();

  return (
    <St.Container>
      <St.Descriptor>
        <span>{t('DESIGN_PAGE.DESCRIPTION.MAIN')}</span>
        <DrawingAreaText
          strongText={t('DESIGN_PAGE.DESCRIPTION.PREDEFINED_SHAPE.BOLD')}
          normalText={t('DESIGN_PAGE.DESCRIPTION.PREDEFINED_SHAPE.NORMAL')}
          IconComponent={AddShapeIcon}
        />
        <DrawingAreaText
          strongText={t('DESIGN_PAGE.DESCRIPTION.FREE_DRAW.BOLD')}
          normalText={t('DESIGN_PAGE.DESCRIPTION.FREE_DRAW.NORMAL')}
          IconComponent={DrawIcon}
        />
        <DrawingAreaText
          strongText={t('DESIGN_PAGE.DESCRIPTION.QUICK_ESTIMATE.BOLD')}
          normalText={t('DESIGN_PAGE.DESCRIPTION.QUICK_ESTIMATE.NORMAL')}
          IconComponent={QuickEstimateIcon}
        />
      </St.Descriptor>
    </St.Container>
  );
};

export default DrawingAreaDescriptor;
